export const FIREBASE_LOGIN_ERRORS = {
  "Firebase: Error (auth/email-already-in-use).": "A user with that email already exists",
  "Firebase: Error (auth/user-not-found).": "User not found",
  "Firebase: Error (auth/wrong-password).": "Invalid password",
};
